module.exports = __webpack_public_path__ + "static/media/github.bc00576b.svg";